import { useTranslation } from "react-i18next";

// styles
require("../TopBarWithBreadCrumb.css");

interface Props {
  onClick: any;
  text: string;
  id?: any;
  iconClass?: string;
  bold?: boolean;
}

const Button = (props: Props) => {
  const { t } = useTranslation();

  return (
    <a
      className="btn btn-sm btn-primary"
      onClick={() => { props.onClick() }
      }
      style={{ backgroundColor: " #55acee;", fontWeight: !!props.bold ? 'bold' : 'normal' }}
      role="button"
    >
      <i className={props.iconClass ?? "fas fa-plus-circle me-2"}></i>
      {props.text}
    </a>
  );
};

export default Button;
